import React from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
  } from "react-google-maps";
import MarkerWithInfoBox from "components/markerWithInfoBox"
  
  const MapWithAMakredInfoWindow = withScriptjs(withGoogleMap((props) => {
    return (
        <GoogleMap
            defaultZoom={5}
            defaultCenter={{ lat: 20.5937, lng: 78.9629 }}
        >
            {props.sitesData.length > 0 && props.sitesData.map((site, index)=> 
                <MarkerWithInfoBox key={index} site={site} />
            )}
        </GoogleMap>
    )}
  ));

  export default MapWithAMakredInfoWindow;